import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import ProjectShowcase from "@/components/project/Sections";
import aurelia from "@/data/projects/aurelia";

export default function Demo() {
    return (
        <div data-testid="demo-page">
            <div className="border-b border-gold/25 bg-gold/10 px-5 pb-4 pt-24 sm:px-8">
                <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-3">
                    <p className="text-xs leading-relaxed text-gold" data-testid="demo-notice">
                        <span className="font-semibold uppercase tracking-widest">
                            Private concept showcase
                        </span>
                        <span className="mx-2 text-gold/50">·</span>
                        The Aurelia is a fictional project created by Sthaan to demonstrate
                        the platform. Nothing here represents a real property, developer or
                        offering.
                    </p>
                    <Link
                        to="/developers"
                        data-testid="demo-back-link"
                        className="inline-flex items-center gap-1.5 text-xs text-mist transition-colors hover:text-gold"
                    >
                        <ArrowLeft className="h-3.5 w-3.5" />
                        For developers
                    </Link>
                </div>
            </div>
            <ProjectShowcase project={aurelia} />
        </div>
    );
}
